import { createGlobalStyle } from 'styled-components'

const reset = createGlobalStyle`
`

export default reset
